import { APPROVE_EXPENSE_BILLING_STATUS, SPLIT_EXPENSE, UPDATE_EXPENSE } from './query'

export const approveExpenseBillingStatus = async (
  client,
  expenseQuickbooksId,
  billingStatus,
  approveState,
) => {
  const response = await client.query({
    query: APPROVE_EXPENSE_BILLING_STATUS,
    variables: { expenseQuickbooksId, billingStatus, approveState },
  })

  return response.data.approveExpenseBillingStatus
}

export const updateExpense = async (client, _id, expense) => {
  const response = await client.query({
    query: UPDATE_EXPENSE,
    variables: { _id, ...expense },
  })

  return response.data.updateExpense
}

export const splitExpense = async ({ client, _id, amounts, statusses }) => {
  const response = await client.query({
    query: SPLIT_EXPENSE,
    variables: { expenseId: _id, amounts, statusses },
  })

  return response.data.splitExpense
}
